import * as React from 'react';

const CancelCircleFilled64 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 64 64", width: 64, height: 64, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M32 5.33C17.27 5.33 5.33 17.27 5.33 32S17.27 58.67 32 58.67 58.67 46.73 58.67 32 46.73 5.33 32 5.33m10.65 35.19-2.12 2.12-8.52-8.52-8.52 8.52-2.12-2.12L29.89 32l-8.52-8.52 2.12-2.12 8.52 8.52 8.52-8.52 2.12 2.12L34.13 32z"
  }
));
CancelCircleFilled64.Size = 64;
CancelCircleFilled64.Title = "CancelCircleFilled";

export { CancelCircleFilled64 as default };
